import { atom } from 'jotai';
import { atomWithDefault } from 'jotai/utils';
import { AutocompleteEpisode, AutocompleteItem, AutocompleteSeason, ShortMediaInfo } from '@shared/types';

export const selectedMediaAtom = atom<AutocompleteItem | null>(null);

export const selectedSeasonAtom = atom<AutocompleteSeason | null>(null);

export const selectedEpisodeAtom = atom<AutocompleteEpisode | null>(null);

export const selectedMediaInfoAtom = atomWithDefault<ShortMediaInfo | null>((get) => {
  const media = get(selectedMediaAtom);
  const season = get(selectedSeasonAtom);
  const episode = get(selectedEpisodeAtom);

  if (!media) return null;

  const tag = media.type === 'movie' ? 'MOVIE' : season && episode ? `S${season.num.toString().padStart(2, '0')}E${episode.num.toString().padStart(2, '0')}` : undefined;

  return {
    title: media.originalTitle,
    subtitle: episode?.title,
    year: parseInt(media.year, 10),
    poster: media.poster,
    tag,
  };
});
